import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MERCHANDISING_COLLECTION_SLICE_PRODUCTS_QUERY_KEY } from './useGetMerchandisingCollectionSliceProducts';

import MerchandisingCollectionsService, {
  ReorderMerchandisingCollectionSliceProductDto,
} from '@/services/MerchandisingCollectionsService';

export function useReorderMerchandisingCollectionSliceProduct() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      collectionId,
      sliceId,
      dto,
    }: {
      collectionId: number;
      sliceId: number;
      dto: ReorderMerchandisingCollectionSliceProductDto;
    }) =>
      MerchandisingCollectionsService.reorderSliceProduct(
        collectionId,
        sliceId,
        dto,
      ),
    onSuccess: (_data, variables) => {
      const SLICE_PRODUCTS_QUERY_KEY = [
        ...MERCHANDISING_COLLECTION_SLICE_PRODUCTS_QUERY_KEY,
        variables.collectionId,
        variables.sliceId,
      ];

      queryClient.invalidateQueries({
        queryKey: SLICE_PRODUCTS_QUERY_KEY,
      });
    },
  });

  return {
    reorderSliceProduct: mutateAsync,
    isLoading: isPending,
  };
}
